module.exports = __webpack_public_path__ + "static/holding-logo--light-f5857bd7ae74c0d91909dc6d85afc384.png";